(() => {
  'use strict';
  if (window.__SQ_QUEEN_LIFE_CURATION_V2__) return;
  window.__SQ_QUEEN_LIFE_CURATION_V2__ = true;
  window.__SQ_QUEEN_LIFE_CURATION_V1__ = true;

  const MAX_RENDER = 30;
  const SOURCE_BATCH = 4;
  const SOURCE_LIMIT = 18;
  const COLLECTIONS = ['queen-life-trending','signature-dresses','most-loved-styles','the-vacation-edit','carry-the-moment','soft-loungewear','polished-accessories'];
  const SEARCHES = ['silk satin','satin dress','silk dress','handbag','shoes','slippers'];
  const cache = new Map();
  const pending = new WeakMap();
  const clean = v => String(v || '').trim();
  const rnd = n => { if (n <= 1) return 0; try { const a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] % n; } catch { return Math.floor(Math.random() * n); } };
  const shuffle = list => { const out = [...list]; for (let i = out.length - 1; i > 0; i--) { const j = rnd(i + 1); [out[i], out[j]] = [out[j], out[i]]; } return out; };
  const isQueenLife = a => { if (!(a instanceof HTMLAnchorElement)) return false; const text = clean(a.textContent).toLowerCase(); let u; try { u = new URL(a.href, location.origin); } catch { return text === 'queen life'; } return text === 'queen life' || u.pathname.includes('queen-life-trending') || (u.pathname === '/search' && clean(u.searchParams.get('q')).toLowerCase() === 'queen life'); };
  const submenu = a => a.closest('.menu-list__submenu') || a.closest('.menu-list__list-item')?.querySelector(':scope>.menu-list__submenu');
  const preview = a => submenu(a)?.querySelector('[data-sq-menu-product-preview]');
  const productImage = p => { const x = Array.isArray(p?.images) ? p.images[0] : null; return typeof x === 'string' ? x : clean(x?.src || p?.image?.src || p?.featured_image); };
  const card = p => { const src = productImage(p); if (!p?.handle || !src) return null; const a = document.createElement('a'); a.className = 'sq-menu-product-card'; a.href = `/products/${encodeURIComponent(p.handle)}`; a.dataset.sqMenuProductCard = ''; a.dataset.productKey = String(p.id || p.handle); a.setAttribute('aria-label', p.title || 'View product'); const media = document.createElement('span'); media.className = 'sq-menu-product-card__media'; const img = document.createElement('img'); img.src = src; img.alt = p.title || ''; img.width = 560; img.height = 700; img.loading = 'lazy'; img.decoding = 'async'; media.appendChild(img); const title = document.createElement('span'); title.className = 'sq-menu-product-card__title'; title.textContent = p.title || ''; a.append(media, title); return a; };

  async function collection(handle) {
    const key = `c:${handle}`;
    if (cache.has(key)) return cache.get(key).map(n => n.cloneNode(true));
    const r = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${SOURCE_LIMIT}&page=1`, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!r.ok) return [];
    const d = await r.json();
    const cards = (d.products || []).slice(0, SOURCE_LIMIT).map(card).filter(Boolean);
    cache.set(key, cards);
    return cards.map(n => n.cloneNode(true));
  }

  async function search(q) {
    const key = `s:${q}`;
    if (cache.has(key)) return cache.get(key).map(n => n.cloneNode(true));
    const u = new URL('/search', location.origin);
    u.searchParams.set('type', 'product');
    u.searchParams.set('q', q);
    u.searchParams.set('view', 'sq-menu');
    const r = await fetch(u, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!r.ok) return [];
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const cards = [...doc.querySelectorAll('[data-sq-menu-search-results] .sq-menu-product-card')].slice(0, SOURCE_LIMIT).map(n => n.cloneNode(true));
    cache.set(key, cards);
    return cards.map(n => n.cloneNode(true));
  }

  const sourceList = () => {
    const primary = { kind: 'collection', value: 'queen-life-trending' };
    const rest = [
      ...COLLECTIONS.filter(value => value !== 'queen-life-trending').map(value => ({ kind: 'collection', value })),
      ...SEARCHES.map(value => ({ kind: 'search', value }))
    ];
    return [primary, ...shuffle(rest)];
  };
  const loadSource = source => source.kind === 'collection' ? collection(source.value) : search(source.value);

  async function curate(anchor) {
    const host = preview(anchor);
    if (!host) return;
    const token = {};
    pending.set(host, token);
    const sources = sourceList();
    const firstWave = sources.slice(0, SOURCE_BATCH);
    const groups = await Promise.allSettled(firstWave.map(loadSource));
    if (pending.get(host) !== token) return;

    const seen = new Set(), all = [];
    const ingest = list => {
      for (const c of list) {
        const k = c.dataset.productKey || c.href;
        if (!k || seen.has(k)) continue;
        seen.add(k);
        all.push(c);
      }
    };
    for (const g of groups) if (g.status === 'fulfilled') ingest(g.value);

    if (all.length < 10) {
      for (const source of sources.slice(SOURCE_BATCH, SOURCE_BATCH + 2)) {
        try { ingest(await loadSource(source)); } catch (_) {}
        if (all.length >= 10 || pending.get(host) !== token) break;
      }
    }
    if (pending.get(host) !== token) return;

    const track = host.querySelector('[data-sq-menu-preview-track]');
    if (!track) return;
    const picks = shuffle(all).slice(0, MAX_RENDER);
    const frag = document.createDocumentFragment();
    picks.forEach((c, i) => {
      const img = c.querySelector('img');
      if (img) {
        img.loading = i < 5 ? 'eager' : 'lazy';
        img.decoding = 'async';
        img.fetchPriority = i < 2 ? 'high' : 'auto';
      }
      frag.appendChild(c);
    });
    track.replaceChildren(frag);
    host.querySelector('[data-sq-menu-preview-title]')?.replaceChildren(document.createTextNode('Queen Life'));
    const hint = host.querySelector('.sq-menu-product-preview__hint');
    if (hint) hint.textContent = `Swipe to browse ${picks.length} curated pieces`;
    host.querySelector('[data-sq-menu-preview-viewport]')?.scrollTo({ left: 0, behavior: 'auto' });
    host.dispatchEvent(new CustomEvent('sq:menu-curated', { bubbles: true }));
  }

  function handle(e) {
    const a = e.target instanceof Element ? e.target.closest('#header-component .mega-menu__link[href]') : null;
    if (!isQueenLife(a)) return;
    setTimeout(() => void curate(a), 180);
  }
  document.addEventListener('pointerover', e => {
    if (!(e.target instanceof Element)) return;
    const a = e.target.closest('#header-component .mega-menu__link[href]');
    if (a && isQueenLife(a) && !a.contains(e.relatedTarget)) handle(e);
  }, true);
  document.addEventListener('focusin', handle, true);
})();
